module.exports = __webpack_public_path__ + "static/media/JourneyMaps2.209d6925.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/zerowaste/JourneyMaps2.jpg
// module id = 207
// module chunks = 0